/* eslint-disable max-len */
import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';

const useStyles = makeStyles(() => ({
  root: {
    width: '1em',
    height: '1em',
  },
}));

export default function SvLang({ className }) {
  const classes = useStyles();
  return (
    <SvgIcon viewBox='0 0 21 14' className={classnames(classes.root, className)}>
      <g id='swe' transform='translate(-1157 -178)'>
        <g id='sweden' transform='translate(1157 178)' stroke='#808f94' strokeWidth='1'>
          <rect width='21' height='14' rx='2' fill='#006aa7' stroke='none' />
          <rect x='7' y='0' width='3' height='14' fill='#fecc00' stroke='none' />
          <rect x='0' y='5.5' width='21' height='3' fill='#fecc00' stroke='none' />
          <rect x='0.5' y='0.5' width='20' height='13' rx='1.5' fill='none' />
        </g>
      </g>
    </SvgIcon>
  );
}
